/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1ProgramEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_PROGRAM_EVENT_ENTITY_NAME = 'ixm.userauth.v1.ProgramEvent';
export const ixmUserauthV1ProgramEventEntity = new schema.Entity<IxmUserauthV1ProgramEvent>(IXM_USERAUTH_V1_PROGRAM_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1ProgramEvent) => `${entity.metadata?.eventId}` });

